/***
 * @ngdoc directive
 * @name BB:bbMonthCalendar
 * @restrict AE
 * @scope true
 *
 * @description
 *
 * Loads a list of month availability for the currently in scope company
 *
 * <pre>
 * restrict: 'AE'
 * replace: true
 * scope: true
 * </pre>
 *
 * @property {string} message The message text
 * @property {string} setLoaded  Set the day list loaded
 * @property {object} setLoadedAndShowError Set loaded and show error
 * @property {object} alert The alert service - see {@link BB:Alert Alert Service}
 */


angular.module('BBPublicBooking').directive('bbMonthCalendar', () => {
        return {
            restrict: 'A',
            replace: true,
            scope: true,
            controller: 'MonthCalendar'
        };
    }
);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/month-calendar/bb_month_calendar.directive.js